export interface IPaymentV2ErrorCountResponseEntry {
  errorCode: string;
  count: number;
  errorMessages: string[];
}

export interface IPaymentV2ErrorCountResponse {
  maxRetryExceededCount: number;
  queueTotalCount: number;
  queueMoreThan48HoursCount: number;
  otherErrors: IPaymentV2ErrorCountResponseEntry[];
}

export interface IRetryExceededPaymentV2CountQueryResponse {
  retryExceededPaymentV2Count: IPaymentV2ErrorCountResponse;
}

export const retryExceededPaymentV2CountQuery = `
  query count {
    retryExceededPaymentV2Count {
      maxRetryExceededCount
      queueTotalCount
      queueMoreThan48HoursCount
      otherErrors {
        count
        errorCode
        errorMessages
      }
    }
  }
`;
